import { ErrorHandler, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { BrowserModule } from '@angular/platform-browser';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener'
import { Firebase } from '@ionic-native/firebase';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { CalendarModule } from "ion2-calendar";
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';
import { GlobalVars } from './app.environment';
import { FIREBASE_CONFIG } from './app.firebase.config';

// Pàgines
import { AnnulmentsPageModule } from '../pages/annulments/annulments.module';
import { AreasPageModule } from '../pages/areas/areas.module';
import { CircularsPageModule } from '../pages/circulars/circulars.module';
import { ConfigurationPageModule } from '../pages/configuration/configuration.module';
import { HomePageModule } from '../pages/home/home.module';
import { LoginPageModule } from '../pages/login/login.module';
import { MailboxPageModule } from '../pages/mailbox/mailbox.module';
import { PayrollPageModule } from '../pages/payroll/payroll.module';
import { PetitionAbsencePageModule } from '../pages/petition-absence/petition-absence.module';
import { PetitionExtraHoursPageModule } from '../pages/petition-extra-hours/petition-extra-hours.module';
import { PetitionHourCompensationPageModule } from '../pages/petition-hour-compensation/petition-hour-compensation.module';
import { PetitionsHistoryPageModule } from '../pages/petitions-history/petitions-history.module';
import { PetitionsStatePageModule } from '../pages/petitions-state/petitions-state.module';
import { ReportGlobalPageModule } from '../pages/report-global/report-global.module';
import { ReportMonthPageModule } from '../pages/report-month/report-month.module';
import { ReportSelectionPageModule } from '../pages/report-selection/report-selection.module';
import { ReportUserPageModule } from '../pages/report-user/report-user.module';
import { TasksPageModule } from '../pages/tasks/tasks.module';
import { UsersPageModule } from '../pages/users/users.module';
import { WorkDaysPageModule } from '../pages/work-days/work-days.module';

// Providers
import { AreaProvider } from '../providers/area/area';
import { AuthProvider } from '../providers/auth/auth';
import { CoefficientProvider } from '../providers/coefficient/coefficient';
import { ConfigurationProvider } from '../providers/configuration/configuration';
import { FirebaseProvider } from '../providers/firebase/firebase';
import { NotificationProvider } from '../providers/notification/notification';
import { PetitionProvider } from '../providers/petition/petition';
import { ReportProvider } from '../providers/report/report';
import { UserProvider } from '../providers/user/user';
import { WorkDaysProvider } from '../providers/work-days/work-days';


@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    CalendarModule,
    IonicModule.forRoot(MyApp, {
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    }),
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    AngularFireAuthModule,
    AngularFireDatabaseModule,

    AnnulmentsPageModule,
    HomePageModule,
    MailboxPageModule,
    LoginPageModule,
    ConfigurationPageModule,
    AreasPageModule,
    UsersPageModule,
    PetitionAbsencePageModule,
    TasksPageModule,
    WorkDaysPageModule,
    PetitionExtraHoursPageModule,
    PetitionHourCompensationPageModule,
    ReportSelectionPageModule,
    ReportGlobalPageModule,
    ReportUserPageModule,
    ReportMonthPageModule,
    PetitionsStatePageModule,
    PetitionsHistoryPageModule,
    CircularsPageModule,
    PayrollPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    GlobalVars,
    File,
    FileOpener,
    Firebase,
    
    AuthProvider,
    FirebaseProvider,
    UserProvider,
    ConfigurationProvider,
    PetitionProvider,
    AreaProvider,
    WorkDaysProvider,
    CoefficientProvider,
    ReportProvider,
    NotificationProvider,
  ],

})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts